var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.4765 14H38.4634L29.7533 24.1662L40 38H31.9757L25.6917 29.6098L18.5015 38H14.5122L23.8285 27.1262L14 14H22.2256L27.9057 21.6689L34.4741 14H34.4765ZM33.0773 35.5631H35.2864L21.0264 16.3089H18.6557L33.0773 35.5631Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwWhite);
export default __webpack_public_path__ + "static/media/tw_white.fc4e5cf7e99a1e3ca79efc2406a00851.svg";
export { ForwardRef as ReactComponent };